import React from 'react';
import { useSelector } from 'react-redux';

import { selectCustomerFeatureAssociationByKey } from '@sophocles/features/featureFlags/slice';
import MeasurementDataView from '@sophocles/views/sites/MeasurementDataView';
import PowerDataView from '@sophocles/views/sites/PowerDataView';
import { useSiteDashboardLayoutContext } from '@sophocles/views/sites/SiteDashboardLayout';

function ReadingsRouterView(props) {
  const { customer, unit } = useSiteDashboardLayoutContext();
  const customerId = customer?.get('id', 0);
  const newReadingsFeature = useSelector(selectCustomerFeatureAssociationByKey(customerId, 'NEW_READINGS_VIEW'));
  const supportsV2Protocol = unit?.firmware_version?.supports_v2_protocol ?? false;

  if (supportsV2Protocol || newReadingsFeature?.is_enabled) {
    return <MeasurementDataView {...props} />;
  }

  return <PowerDataView {...props} />;
}

export default ReadingsRouterView;
